import { InjectionToken } from '@angular/core';

export const API_ROOT = new InjectionToken<string>('api_root');
